import { useEffect, useState } from "react";
import styled from "styled-components";
import SESI from "../../assets/img/sesi.png";
import {
  getCnpj,
  getEmailsCNPJ,
  setAndSendEmail,
} from "../../data/services/enterprise_service";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getContractAssociatedInfo } from "../../data/services/crew_service";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #e5f8fa;
  height: 100vh;
  position: relative;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  top: 140px;
  left: 200px;
  margin: 0;

  h1 {
    color: #ff5742;
    font-size: 30px;
    font-weight: 600;
    text-align: left;
    margin: 0;
  }
`;

const SesiImage = styled.img`
  width: 200px;
  height: 90px;
  margin: 0;
`;

const SelectionBox = styled.div`
  display: flex;
  flex-direction: row;
  width: 70%;
  justify-content: center;
  align-items: center;
  padding: 16px;
  border-radius: 8px;
  text-align: center;
  gap: 350px;

  p {
    color: #ff5742;
    font-size: 30px;
    font-weight: 600;
    width: 500px;
  }
`;

const EmailList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  max-height: 200px;
  overflow-y: auto;
`;

const EmailButton = styled.button<{ selected?: boolean; width?: number }>`
  padding: 8px;
  border: 1px solid #ccc;
  min-width: ${(props) => props.width}px;
  border-radius: 8px;
  background-color: ${(props) => (props.selected ? "#005CA9" : "white")};
  color: ${(props) => (props.selected ? "white" : "black")};
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #f0f0f0;
  }
`;

const ConfirmButton = styled.button<{ disabled: boolean }>`
  margin-top: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  background-color: #007bff;
  color: white;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};
`;

export default function EmailSelection() {
  const [emails, setEmails] = useState<string[]>([]);
  const [selectedEmail, setSelectedEmail] = useState<string | null>(null);
  const [maxWidth, setMaxWidth] = useState(200);
  const [isLoading, setIsLoading] = useState(false);
  const cnpj = getCnpj();

  useEffect(() => {
    async function fetchEmails() {
      if (cnpj.length === 14) {
        try {
          const responseData = await getEmailsCNPJ(cnpj);
          if (Array.isArray(responseData)) {
            setEmails(responseData);
            const maxLength = Math.max(
              ...responseData.map((email) => email.length)
            );
            const newWidth = maxLength * 10;
            setMaxWidth(newWidth);
          }
        } catch (error) {
          console.error("Erro ao buscar e-mails:", error);
        }
      } else if (cnpj.length === 11) {
        try {
          const { contract } = await getContractAssociatedInfo(cnpj);
          if (contract && contract.emailCob) {
            setEmails([contract.emailCob]);
          }
        } catch (error) {
          console.error("Erro ao buscar email do CPF:", error);
        }
      }
    }

    fetchEmails();
  }, [cnpj]);

  const handleClick = async () => {
    if (!selectedEmail || isLoading) return;

    setIsLoading(true);

    try {
      const responseData = await setAndSendEmail(selectedEmail);

      if (responseData.statusCode === 200 || responseData.statusCode === 201) {
        toast.success("Email enviado para o endereço selecionado!", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        toast.success("Email enviado para o endereço selecionado!");
      }
    } catch (error) {
      console.error("Erro ao enviar email:", error);
      toast.error("Erro ao enviar o email. Tente novamente.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <ToastContainer />
      <Header>
        <SesiImage src={SESI} alt="Sesi Logo" />
        <h1>PORTAL DO CLIENTE</h1>
      </Header>
      <SelectionBox>
        {cnpj.length === 14 ? (
          <p>Selecione o e-mail que deseja colocar como principal:</p>
        ) : (
          <p>Confirme se o endereço de email está correto </p>
        )}
        <EmailList>
          {emails.length > 0 ? (
            emails.map((email) => (
              <EmailButton
                key={email}
                selected={selectedEmail === email}
                onClick={() => setSelectedEmail(email)}
                width={maxWidth}
              >
                {email}
              </EmailButton>
            ))
          ) : (
            <p>Carregando e-mails...</p>
          )}
        </EmailList>
      </SelectionBox>
      <ConfirmButton disabled={!selectedEmail || isLoading} onClick={handleClick}>
        {isLoading ? "Enviando..." : "Confirmar Email"}
      </ConfirmButton>
    </Container>
  );
}
